const ITEMS = [
  "TIENDAS",
  "restaurantes",
  "PELUQUERÍAS",
  "centros de estética",
  "OFICINAS",
  "comercio de proximidad",
];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 ${
              i % 2 === 0
                ? "font-oswald text-2xl md:text-4xl tracking-[0.15em] text-silver/80"
                : "font-cormorant text-3xl md:text-5xl text-steel"
            }`}
          >
            {item}
          </span>
          <span className="h-1.5 w-1.5 bg-glow/60 rotate-45" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="relative overflow-hidden border-y border-silver/10 bg-abyss/60 py-7"
      data-testid="marquee"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
